<template>
  <div class="">
    <div class="panal mt-20">
      <div class="panal-header">Booking Room</div>
      <div class="panal-body">
  
<div class="row">
        
            <div class="col-12 col-md-6 mb-1">
              <label>Room Gatgory </label>
    <b-form-select v-model="selected.reservationTypeId" :options="Rooms" value-field="Serial" v-b-tooltip.hover title="Room Gatgory" text-field="Room_Category" class="form-control su-border"></b-form-select>
</div>
       <div class="col-12 col-md-6 mb-1">
         <label>Period </label>
    <b-form-select v-model="selected.periodid" :options="period"  class="form-control su-border"  v-b-tooltip.hover title="Period" value-field="Serial" text-field="DurationName"></b-form-select>
</div>

<!-- <div class="mt-3 col-12">Selected: <strong> {{ selected }} </strong></div>


       <div class="col-12 col-md-12 mb-1 mt-2">
         <label>Room Descriptaion  </label>
<b-alert show>Room Descriptaion ........</b-alert>
    
</div> -->
<div class="clearfix"></div>
 <div class="text-center mt-3 col-12">   
       <a href="#"  class="btn btn-primary" @click="GetPrice">Confirm </a>


           
           
           </div>


</div>

      </div>
    </div>
            <b-modal id="Confirm" title="Booking Information" :header-bg-variant="headerBgVariant" ok-only size="lg"  @ok=ConfirmResrvation>
  
  <div class="row">
<div class="col-3">Available Room  :</div>
<div class="col-8 form-control su-border">{{show ? RoomData.DataList[0].AvailableRoom : ''}}</div>

<div class="clearfix mt-10 mb-10"></div>
<div class="col-3 mt-10">Period :</div>
<div class="col-8 mt-10 form-control su-border">{{show ? RoomData.DataList[0].DurationName : ''}}</div>

<div class="clearfix mt-10 mb-10 "></div>
<div class="col-3 mt-10">The amount :</div>
<div class="col-8 mt-10 form-control su-border">{{show ? RoomData.DataList[0].Price : ''}}</div>

<div class="clearfix mt-10 mb-10 "></div>
<div class="col-3 mt-10">Gender:</div>
<div class="col-8 mt-10 form-control su-border">{{show ? Gender : ''}}</div>

<div class="clearfix mt-10 mb-10 "></div>
<div class="col-3 mt-10">Room Descriptaion  :</div>
<div class="col-8 mt-10 form-control su-border">{{show ? RoomData.DataList[0].Description : ''}}</div>
<div class="col-12 mt-3">
<b-alert show variant="danger">{{show ? RoomData.msg : ''}}</b-alert>
</div>
  </div>
  </b-modal>
  </div>
</template>

<script>



import DormsServices from '../../services/Dorms/Dorms.service'

export default {
  name: "Destinations",
  props:['period','Rooms','Gender'],
  data() {
    return {
       headerBgVariant: 'primary',
      selected: {
        periodid : '',
        reservationTypeId : ''
      },
        RoomData:{
          DataList : []
        },
        show:false
        

    };
  },

  mounted(){
 
    

  },
   computed:{
          currenUser(){
            return  this.$store.state.auth.user
          },
        
        },
  methods:{
      GetPrice(){
        this.show =false
        DormsServices.GetAll_ReservationPriceAndAvailableRooms(this.selected.reservationTypeId,this.selected.periodid).then(respone=>{
          console.log(respone.data)
           this.show =true
          this.RoomData = respone.data
         
          this.$bvModal.show("Confirm")
          
        })
      },
      ConfirmResrvation(){
      let   ConfirmObj= {
          UserID :this.currenUser.UserIDSerial ,
          ApplicantID : this.currenUser.UserIDSerial,
          Price :this.RoomData.DataList[0].Price ,
          GracePeriod :this.RoomData.DataList[0].GracePeriod , 
          PersonCategoryID : 1,
          PersonCode : this.currenUser.Username ,
          PersonName : this.currenUser.FirstNameEN + ' ' + this.currenUser.SecondNameEN + ' ' + this.currenUser.ThirdNameEN + ' ' + this.currenUser.LastNameEN,
          RoomReservationID :this.RoomData.DataList[0].RoomReservationID
        }
        console.log(ConfirmObj)
        DormsServices.confirm(ConfirmObj).then(response=>{
          console.log(response.data)
          alert("done")
        }).catch(err=> console.log(err))
      }
  }
}
</script>

<style scoped>
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}
table tr th {
  background-color: #4caf5000 !important;
  color: #333;
  font-weight: bold;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  border: 1px solid #d4d4d4;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}

.divider {
  *width: 100%;
  height: 1px;
  margin: 9px 1px;
  *margin: -5px 0 5px;
  overflow: hidden;
  /* background-color: #e5e5e5; */
  border-bottom: 1px dotted #e5e5e5;
}
.su-border {
  border-color: #3d8fe3 !important;
  background: #f1f9ff !important;
}
.panal-body {
  padding: 20px;
  color: #333;
}
.app-stu-photo {
  float: right;
  width: 200px;
  border-radius: 10px;
  border: 1px solid #111;
  margin-top: 20px;
}
.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}
.app-All {
  width: 80%;
  float: left;
}
.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;
}
.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-light th {
  font-size: 14px !important;
}
.table .thead-light th {
  font-size: 14px !important;
  background-color: #eaeaea !important;
}

.panal2 {
  background: #eee;
  border-radius: 10px;
  color: #333;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header2 {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body2 {
  padding: 20px;
  color: #333;
}
.mt-10 {
  margin-top: 10px;
}

.btn {
  margin-left: 5px;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}
</style>